import { DetailedEmailCampaign, EmailCampaignNotes, FetchEmailCampaignsFilters } from '@/types';
import api from '@/api/API';
import eventBus from '@/messaging/event-bus';
import { EmailReportGenerated, EmailCampaignsFetched } from '@/messaging/events';

export function fetch(accountId: string, filters: FetchEmailCampaignsFilters): Promise<void> {
  return api
    .post(`accounts/${accountId}/email-campaigns`, filters)
    .then(() => {
      eventBus.$emit(EmailCampaignsFetched.eventName);
    });
}

export function updateNotes(id: string, notes: EmailCampaignNotes): Promise<EmailCampaignNotes> {
  return api
    .put(`email-campaigns/${id}/notes`, { notes })
    .then(response => response.data);
}

export function generateReport(id: string): Promise<DetailedEmailCampaign> {
  return api
    .post(`email-campaigns/${id}`)
    .then((response) => {
      const emailCampaign: DetailedEmailCampaign = response.data;
      eventBus.$emit(EmailReportGenerated.eventName, emailCampaign);
      return emailCampaign;
    });
}

export function submitNotes(emailCampaignId: string): Promise<void> {
  return api
    .put(`reports/${emailCampaignId}/notes`)
    .then(response => response.data);
}

export function refresh(id: string): Promise<DetailedEmailCampaign> {
  return api
    .put(`email-campaigns/${id}`)
    .then(response => response.data);
}
